export default {
  noBorderBottom:{},
  large: {},
  short: {},
  contentModule: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    width: '100%',
  },
  contentModuleRow: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  contentModuleCell: {
    display: 'table-cell',
    '&$short': {
      width: '35%'
    },
    '&$large': {
      width: '65%'
    },
  },
  contentModuleCellTitle: {
    font: "500 15px 'Roboto', sans-serif",
  },
  contentModuleCellPrice: {
    font: "500 15px 'Roboto', sans-serif",
    textAlign: 'right',
    '&:lang(ar)': {
      textAlign: "left"
    }
  },
  contentModuleCellService: {
    font: "300 15px 'Roboto', sans-serif",
    color: '#666666',
  },
  priceNumbers:{
    font: "300 13px 'Roboto', sans-serif",
    color: '#666',
  },
  fontWeight300:{
    fontWeight: '300',
  },
  serviceDayFormat: {
    paddingLeft: '24px',
    color: '#666666',
  },
  serviceContainer: {
    paddingLeft: '24px',
    textIndent: '-24px',
  }
}